import React from 'react'
import { motion } from 'framer-motion'
export function NiyyahLogo() {
  return (
    <div className="relative inline-block">
      {/* The text with exact hero gradient + grain texture */}
      <motion.h1
        className="text-3xl font-semibold tracking-tight"
        initial={{
          opacity: 0,
          y: -10,
        }}
        animate={{
          opacity: 1,
          y: 0,
        }}
        transition={{
          duration: 0.8,
          ease: 'easeOut',
        }}
      >
        <span className="relative z-10 logo-gradient">Niyyah</span>
      </motion.h1>

      {/* Animated glow effect matching the gradient colors */}
      <motion.div
        className="absolute -inset-4 blur-xl rounded-full opacity-30 z-0"
        style={{
          background:
            'radial-gradient(circle, rgba(122, 107, 168, 0.4) 0%, rgba(123, 165, 217, 0.3) 40%, rgba(107, 196, 224, 0.2) 70%, transparent 100%)',
        }}
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.3, 0.5, 0.3],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      <style>{`
        .logo-gradient {
          background-image:
            url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='1.5' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E"),
            linear-gradient(
              135deg,
              #7a6ba8 0%,
              #8b7db8 12%,
              #9b8fc4 25%,
              #8c9ed8 38%,
              #7ba5d9 50%,
              #6bc4e0 62%,
              #b89bc8 75%,
              #9b8fc4 88%,
              #7a6ba8 100%
            );
          background-size:
            200px 200px,
            400% 400%;
          background-blend-mode: overlay, normal;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: logoGradientFluctuate 12s ease-in-out infinite;
        }

        @keyframes logoGradientFluctuate {
          0%,
          100% {
            background-position:
              0px 0px,
              0% 50%;
          }
          25% {
            background-position:
              0px 0px,
              100% 50%;
          }
          50% {
            background-position:
              0px 0px,
              50% 100%;
          }
          75% {
            background-position:
              0px 0px,
              0% 100%;
          }
        }
      `}</style>
    </div>
  )
}